import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  boxDetails: {
    width: '80%',
    marginLeft: '5%',
    marginTop: '2%',
    paddingBottom: 5,
    paddingTop: 5,
    background: '#f9f9f9',
    borderRadius: 10,
    boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)'
  },
  boxEstudio: {
    maxHeight: '200px',
    width: '100%',
    paddingTop: 10,
    display: 'flex',
    alignItems: 'center',
  },
  buttonEditModule: {
    height: '28px',
    width: 80,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    background: '#f9f9f9',
    marginRight: 5,
    '&:hover': {
      backgroundColor: '#f2f2f2'
    },
    border: '2px solid #028B7E',
    borderRadius: '23px'
  },

  buttonEnabledModule: {
    height: '28px',
    width: 110,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f9f9f9',
    marginRight: 5,

    border: '2px solid #6e7a76',
    borderRadius: '23px'
  },

  typographyButton: {
    fontFamily: 'Raleway',
    fontSize: '0.9em',
    letterSpacing: '0.05em',
    color: '#028B7E'
  },
  boxTopes: {
    width: '80%',
    marginLeft: '5%',
    marginTop: '2%',
    marginBottom: 10,
    paddingBottom: 5,
    paddingTop: 5,
    background: '#f9f9f9',
    boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)',
    borderRadius: 10
  },
  boxNav: {
    marginLeft: '10%',
    width: '25%',
    textDecoration: 'none',
    '@media all and (max-width: 1100px)': {
      marginLeft: '5%',
      width: '20%'
    }
  },
  typographyStyle: {
    paddingLeft: '1%',
    fontSize: 15,
    fontWeight: 700,
    textDecoration: 'none',
    '@media all and (max-width: 800px)': {
      fontSize: 14
    },
    '@media all and (max-width: 600px)': {
      fontSize: 13
    }
  },
  boxButton: {
    width: '50%',
    display: 'flex',
    justifyContent: 'flex-start',
    color: '#706E6F',
    '&:hover': {
      color: '#026873'
    }
  },
  boxStyle: {
    width: 250,
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '1%',
    '@media all and (max-width: 600px)': {
      width: 200
    }
  },
  hoverButton: {
    cursor: 'pointer'
  }
}))

export default useStyles
